import React from 'react';

export const HangingPlant = props => (
  <svg width="201px" height="162px" viewBox="0 0 201 162" version="1.1">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-756.000000, -284.000000)">
        <g transform="translate(756.000000, 284.000000)">
          <path
            d="M148.569827,153.828286 L52.4303682,153.828286 L0.508570047,101.847549 C-0.169523349,101.168692 -0.169523349,100.057914 0.508570047,99.3790569 L99.2670336,0.508488428 C99.9459986,-0.169496143 101.054655,-0.169496143 101.732749,0.508488428 L200.492084,99.3790569 C201.169305,100.057914 201.169305,101.168692 200.492084,101.847549 L148.569827,153.828286 Z"
            fill="#F3F4F6"
            fillRule="nonzero"
          />
          <g transform="translate(130.000000, 8.710000)">
            <path d="M0.4835,0.0482 L0.4835,100.5872" fill="#FFFFFF" />
            <path
              d="M0.4835,0.0482 L0.4835,100.5872"
              stroke="#DCE4E7"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <path
            d="M103.0259,109.2973 L124.8299,9.8653"
            stroke="#DCE4E7"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M135.6275,8.7582 L157.6635,109.2972"
            stroke="#DCE4E7"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M94.1959,155.3168 L44.4399,155.3168"
            stroke="#ED0722"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M118.024,109.2338 C112.845,105.3838 107.845,101.2598 103.051,96.8828 C110.791,98.1268 118.124,102.0928 123.626,108.0148 C121.982,105.5788 121.445,102.5238 120.571,99.6718 C118.427,92.6688 114.146,86.6698 109.939,80.8188 C116.523,84.3638 122.695,89.6998 125.215,97.0768 C126.131,99.7558 126.541,102.6348 127.736,105.1868 C126.147,94.6338 127.065,83.6668 130.381,73.5788 C131.49,84.5418 131.712,95.6048 131.045,106.6088 C132.916,106.0048 133.58,103.6038 133.953,101.5628 C134.58,98.1388 135.207,94.7158 135.833,91.2938 C138.051,95.8508 137.557,101.3008 137.007,106.3998 C138.894,96.9858 142.299,87.7588 149.514,82.1098 C148.941,85.7598 145.856,91.6168 143.894,96.7688 C141.933,101.9218 140.54,107.0988 140.54,107.0988 C145.841,105.2998 150.943,102.8378 155.706,99.7778 C153.399,103.7458 149.919,106.9268 145.885,108.7558"
            fill="#5EDAB0"
          />
          <path
            d="M142.4112,100.9506 C141.2672,104.3946 140.5402,107.0986 140.5402,107.0986 C145.8412,105.3006 150.9432,102.8376 155.7052,99.7776 C153.3992,103.7456 149.9192,106.9276 145.8852,108.7566"
            stroke="#575700"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M114.4473,87.2953 C113.0053,85.0893 111.4673,82.9433 109.9393,80.8183 C116.5223,84.3633 122.6953,89.6993 125.2153,97.0763 C126.1313,99.7563 126.5403,102.6353 127.7363,105.1873 C126.1473,94.6343 127.0653,83.6663 130.3813,73.5783 C131.4893,84.5413 131.7123,95.6053 131.0443,106.6083 C132.9153,106.0053 133.5793,103.6043 133.9533,101.5633 C134.5803,98.1393 135.2063,94.7163 135.8333,91.2933 C138.0513,95.8513 137.5563,101.3013 137.0073,106.3993 C138.8943,96.9853 142.2993,87.7593 149.5143,82.1093 C148.9413,85.7603 145.8553,91.6163 143.8943,96.7693"
            stroke="#575700"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M112.8013,99.9867 C116.8223,101.9467 120.5163,104.6687 123.6263,108.0147 C121.9823,105.5787 121.4453,102.5237 120.5713,99.6727 C119.5503,96.3367 118.0443,93.2277 116.2923,90.2567"
            stroke="#575700"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M118.024,109.2338 C112.845,105.3838 107.845,101.2598 103.051,96.8828 C105.4,97.2598 107.713,97.8888 109.947,98.7468"
            stroke="#575700"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M34.44,155.3168 L26.404,155.3168"
            stroke="#ED0722"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M158.2457,109.2973 C158.2457,121.4863 145.8707,131.3683 130.6057,131.3683 C115.3417,131.3683 102.9667,121.4863 102.9667,109.2973 L158.2457,109.2973 Z"
            fill="#FFFFFF"
          />
          <path
            d="M158.2457,109.2973 C158.2457,121.4863 145.8707,131.3683 130.6057,131.3683 C115.3417,131.3683 102.9667,121.4863 102.9667,109.2973 L158.2457,109.2973 Z"
            stroke="#391572"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <g transform="translate(148.000000, 112.710000)">
            <path d="M0.5767,0.0189 L10.3137,0.0189" fill="#FFFFFF" />
            <path
              d="M0.5767,0.0189 L10.3137,0.0189"
              stroke="#D62793"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <g transform="translate(104.000000, 112.710000)">
            <path d="M0.2999,0.0189 L38.5629,0.0189" fill="#FFFFFF" />
            <path
              d="M0.2999,0.0189 L38.5629,0.0189"
              stroke="#D62793"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <path
            d="M87.8526,74.1586 L87.8526,108.9486"
            stroke="#AA81F7"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M85.7603,73.8754 L89.9573,73.8534"
            stroke="#AA81F7"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M85.7603,108.9594 L89.9573,108.9374"
            stroke="#AA81F7"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M72.4263,99.0063 L50.9803,99.0063 C49.9673,99.0063 49.1383,98.1773 49.1383,97.1643 C49.1383,96.1513 49.9673,95.3223 50.9803,95.3223 L72.4263,95.3223 C73.4393,95.3223 74.2683,96.1513 74.2683,97.1643 C74.2683,98.1773 73.4393,99.0063 72.4263,99.0063"
            fill="#DDE5E8"
          />
          <path
            d="M63.2886,104.683 L50.6526,104.683 C49.6396,104.683 48.8106,103.855 48.8106,102.841 C48.8106,101.829 49.6396,100.999 50.6526,100.999 L63.2886,100.999 C64.3016,100.999 65.1306,101.829 65.1306,102.841 C65.1306,103.855 64.3016,104.683 63.2886,104.683"
            fill="#DDE5E8"
          />
          <polygon
            fill="#FFFFFF"
            points="49.725 90.322 64.589 90.322 64.589 75.458 49.725 75.458"
          />
          <polygon
            stroke="#DDE5E8"
            points="49.725 90.322 64.589 90.322 64.589 75.458 49.725 75.458"
          />
          <path
            d="M54.4473,85.3119 C55.1143,86.0559 56.0783,86.5269 57.1563,86.5269 C59.1713,86.5269 60.8033,84.8939 60.8033,82.8799 C60.8033,80.8669 59.1713,79.2339 57.1563,79.2339 C55.1433,79.2339 53.5103,80.8669 53.5103,82.8799 L57.1563,82.8799 L54.4473,85.3119"
            fill="#F5C400"
          />
          <path
            d="M109.939,40.9604 L109.939,42.2754"
            stroke="#F2C217"
            strokeLinecap="round"
          />
          <path
            d="M109.939,44.9076 L109.939,46.2226"
            stroke="#F2C217"
            strokeLinecap="round"
          />
          <path
            d="M112.5704,43.5912 L111.2544,43.5912"
            stroke="#F2C217"
            strokeLinecap="round"
          />
          <path
            d="M108.6231,43.5912 L107.3081,43.5912"
            stroke="#F2C217"
            strokeLinecap="round"
          />
          <path
            d="M170.044,78.3598 C170.044,78.8418 169.653,79.2338 169.17,79.2338 C168.688,79.2338 168.296,78.8418 168.296,78.3598 C168.296,77.8778 168.688,77.4858 169.17,77.4858 C169.653,77.4858 170.044,77.8778 170.044,78.3598"
            fill="#D62793"
          />
          <path
            d="M100.6236,60.7611 C100.6236,61.2431 100.2316,61.6351 99.7496,61.6351 C99.2666,61.6351 98.8756,61.2431 98.8756,60.7611 C98.8756,60.2791 99.2666,59.8871 99.7496,59.8871 C100.2316,59.8871 100.6236,60.2791 100.6236,60.7611"
            fill="#0B9CE5"
          />
          <path
            d="M171.7955,52.1772 L171.7955,53.9272"
            stroke="#AA81F7"
            strokeLinecap="round"
          />
          <path
            d="M171.7955,57.4272 L171.7955,59.1772"
            stroke="#AA81F7"
            strokeLinecap="round"
          />
          <path
            d="M175.2955,55.6772 L173.5455,55.6772"
            stroke="#AA81F7"
            strokeLinecap="round"
          />
          <path
            d="M170.0455,55.6772 L168.2955,55.6772"
            stroke="#AA81F7"
            strokeLinecap="round"
          />
          <path
            d="M149.3331,157.4985 C149.3331,159.8095 140.0261,161.6815 128.5461,161.6815 C117.0661,161.6815 107.7601,159.8095 107.7601,157.4985 C107.7601,155.1885 117.0661,153.3165 128.5461,153.3165 C140.0261,153.3165 149.3331,155.1885 149.3331,157.4985"
            fill="#D0D7DA"
          />
          <path
            d="M113.5518,100.3647 L113.5508,100.3647"
            stroke="#575700"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M148.1973,114.3217 L156.7053,114.3217 C155.5383,120.7907 144.0903,127.2597 144.0903,127.2597 C144.0903,127.2597 148.0003,119.9377 148.1973,114.3217"
            fill="#F3F4F6"
          />
        </g>
      </g>
    </g>
  </svg>
);
